/**
 * @generated SignedSource<<180478a80aa88bf7d9842dc83f1c44ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutFooter_viewer$data = {
  readonly merchantAccounts: ReadonlyArray<{
    readonly countryName: string | null;
    readonly currency: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerIncentives_viewer">;
  readonly " $fragmentType": "CheckoutFooter_viewer";
};
export type CheckoutFooter_viewer$key = {
  readonly " $data"?: CheckoutFooter_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutFooter_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutFooter_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "accountType",
          "value": "TRANSACTION"
        }
      ],
      "concreteType": "MerchantAccount",
      "kind": "LinkedField",
      "name": "merchantAccounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "countryName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": "merchantAccounts(accountType:\"TRANSACTION\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerIncentives_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c8851b600aa8d92f7404fedffaa0d628";

export default node;
